<template>
  <Card :title="id === '1006' ? '五、参加护理查房和护理小讲座记录' : name">
    <div v-for="(d, i) in roomRecord" :key="i">
      <Divider> 记录{{ i + 1 }}</Divider>
      <Field
        v-model="d.time"
        label="时间"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.content"
        :label="
          id === '1006'
            ? '查房内容（病历号及疾病诊断）或 小讲座内容'
            : '查房内容（床号及疾病诊断)'
        "
        :readonly="readonly"
        placeholder="请输入"
        show-word-limit
        type="textarea"
        maxlength="1000"
        rows="2"
      />
      <Field
        v-model="d.person"
        :label="id === '1006' ? '主持人' : '查房者'"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.participant"
        label="参加人员"
        :readonly="readonly"
        placeholder="请输入"
      />
      <div class="action" v-if="!readonly">
        <VanBtn
          round
          @click="delRecord(i)"
          :disabled="roomRecord.length === 1"
          type="danger"
          color="#EA514B"
          size="small"
          >删除</VanBtn
        >
      </div>
    </div>
    <div class="action" v-if="!readonly">
      <VanBtn round type="primary" size="small" @click="addRecord()"
        >添加</VanBtn
      >
    </div>
  </Card>
</template>
<script>
import { Field, Button as VanBtn, Divider } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "RoomRecord",
  props: {
    id: String,
    title: String,
    readonly: Boolean
  },
  data: function() {
    return {
      name: "五、参加护理查房记录",
      roomRecord: [{ time: "", content: "", person: "", participant: "" }]
    };
  },
  methods: {
    addRecord() {
      this.roomRecord.push({
        time: "",
        content: "",
        person: "",
        participant: ""
      });
    },
    delRecord(index) {
      if (this.roomRecord.length === 1) {
        return;
      }
      this.roomRecord.splice(index, 1);
    }
  },
  components: { Card, Field, VanBtn, Divider }
};
</script>
<style lang="scss" scoped>
.action {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  button {
    width: 36%;
  }
}
</style>
